var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialFreezing = function SvgSocialFreezing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "transparent",
    d: "M36.434 20c0 9.076-7.358 16.434-16.434 16.434S3.566 29.076 3.566 20 10.924 3.566 20 3.566 36.434 10.924 36.434 20Zm-1.8 0c0 8.082-6.552 14.634-14.634 14.634S5.366 28.082 5.366 20 11.918 5.366 20 5.366 34.634 11.918 34.634 20Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7,
    d: "M20 13.018v13.964M17.382 10.4 20 13.018l2.618-2.618M17.382 29.6 20 26.982l2.618 2.618M13.953 16.509l12.094 6.982M10.4 17.382l3.553-.873-.935-3.49M26.982 26.982l-.935-3.491 3.553-.873M13.953 23.49l12.094-6.981M13.018 26.982l.935-3.491-3.553-.873M29.6 17.382l-3.553-.873.935-3.49"
  })));
};
export default SvgSocialFreezing;